// extracted by mini-css-extract-plugin
module.exports = {"SeachBox":"search-box_SeachBox__W8np4"};